export const PROJECTS_BIN_ROUTE_NAME = "binProjects";
